export type textProps = {
    productId: string;
    variantId: string;
    title?: string;
    desc: string;
    productUrl: string;
};

export const conf: Record<string, textProps[]> = {
    us: [
        {
            productId: '6964802453577',
            variantId: '40758830071881',
            desc: '6.1kWh Capacity | 7.2kW Output',
            productUrl: 'https://us.ecoflow.com/products/delta-pro-ultra',
        },
        {
            productId: '6585086836809',
            variantId: '40516140138569',
            desc: '3.6kWh Capacity | 3600W Output',
            productUrl: 'https://us.ecoflow.com/products/delta-pro-portable-power-station',
        },
        {
            productId: '7289136054345',
            variantId: '41826182496329',
            desc: '1024Wh Capacity | 1800W Output',
            productUrl: 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station',
        },
        {
            productId: '7185477075017',
            variantId: '41385721004105',
            desc: '4096Wh Capacity | 4000W Output',
            productUrl: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station',
        },
        {
            productId: '6905537888329',
            variantId: '40538145095753',
            desc: '2048Wh Capacity | 2400W Output',
            productUrl: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '6859087282249',
            variantId: '40563653378121',
            desc: '768Wh Capacity I 800W Output',
            productUrl: 'https://us.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    ],
    ca: [
        {
            productId: '8006700236954',
            variantId: '44244774650010',
            desc: '6.1kWh Capacity I 7.2kW Output',
            productUrl: 'https://ca.ecoflow.com/products/delta-pro-ultra-whole-home-backup-power',
        },
        {
            productId: '6944959824026',
            variantId: '43725958873242',
            desc: '3.6kWh Capacity I 3600W Output',
            productUrl: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station',
        },
        {
            productId: '8331157766298',
            variantId: '51645140926835',
            desc: '1024Wh Capacity | 1800W Output',
            productUrl: 'https://ca.ecoflow.com/products/delta-3-plus-portable-power-station',
        },
        {
            productId: '8231332380826',
            variantId: '44902384599194',
            desc: '4096Wh Capacity | 4000W Output',
            productUrl: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station',
        },
        {
            productId: '7825964400794',
            variantId: '43592212775066',
            desc: '2048Wh Capacity | 2400W Output',
            productUrl: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '7539942064282',
            variantId: '43725934461082',
            desc: '768Wh Capacity | 800W Output',
            productUrl: 'https://ca.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    ],
    jp: [
        {
            productId: '8095160795297',
            variantId: '44597213003937',
            title: 'DELTA 3 Plus',
            desc: '容量：1,024Wh | 出力：1,500W | 防災に最適',
            productUrl: 'https://jp.ecoflow.com/products/delta-3-plus-portable-power-station?variant=44597213003937',
        },
        {
            productId: '14684998762863',
            variantId: '51809553744239',
            title: 'DELTA 3 1500',
            desc: '容量：1,500Wh | 出力：1,500W',
            productUrl: 'https://jp.ecoflow.com/products/delta-3-1500-portable-power-station',
        },
        {
            productId: '7700809089185',
            variantId: '43020979863713',
            title: 'DELTA 2 Max',
            desc: '容量：2,048Wh | 出力：2,000W | 車中泊·防災に最適',
            productUrl: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station?variant=43020979863713',
        },
        {
            productId: '6855508918433',
            variantId: '43129277513889',
            title: 'DELTA Pro',
            desc: '容量：3,600Wh | 出力：3,000W',
            productUrl: 'https://jp.ecoflow.com/products/delta-3-plus-portable-power-station?variant=44597212020897',
        },
        {
            productId: '7990573596833',
            variantId: '44261300175009',
            title: 'DELTA Pro 3',
            desc: '容量：4,096Wh | 出力：3,600W',
            productUrl: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station?variant=44616097267873',
        },
        {
            productId: '7569353343137',
            variantId: '43727378153633',
            title: 'RIVER 2 Pro',
            desc: '容量：768Wh | 出力：800W',
            productUrl: 'https://jp.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    ],
    eu: [
        {
            productId: '9744704930135',
            variantId: '49573797593431',
            desc: '1-5kWh Capacity | 1800W Output',
            productUrl: '',
        },
        {
            productId: '8414996627799',
            variantId: '46790633881943',
            desc: '- 2-6kWh Expandable Capacity\n- Run 99% of Appliances with X-Boost',
            productUrl: '',
        },
        {
            productId: '7403706253476',
            variantId: '42596003512484',
            desc: '- 1kWh Capacity\n- 2400W X-Boost',
            productUrl: '',
        },
        {
            productId: '7346811961508',
            variantId: '46933291663703',
            desc: '23% conversion rate | Up to a 10-year warranty',
            productUrl: '',
        },
        {
            productId: '9604647747927',
            variantId: '49178411303255',
            desc: 'Qi2 15W Wireless Charging | Up to 30W Input/Output',
            productUrl: '',
        },
        {
            productId: '7472877699236',
            variantId: '46822242713943',
            desc: '768Wh Capacity | 800W Output',
            productUrl: '',
        },
    ],
    uk: [
        {
            productId: '9606214418771',
            variantId: '49797546836307',
            desc: '245Wh Capacity | 300W Output',
            productUrl: '',
        },
        {
            productId: '9616877420883',
            variantId: '49833568993619',
            desc: '1-5kWh Capacity | 1800W Output',
            productUrl: '',
        },
        {
            productId: '9430789095763',
            variantId: '49700418027859',
            desc: 'Qi2 15W Wireless Charging | Up to 30W Input/Output',
            productUrl: '',
        },
        {
            productId: '9430243180883',
            variantId: '49296152723795',
            desc: '4kWh capacity | 4000W Output | LFP | 30 dB',
            productUrl: '',
        },
        {
            productId: '8416984367443',
            variantId: '46679851139411',
            desc: '- 2-6kWh Expandable Capacity\n- Run 99% of Appliances with X-Boost',
            productUrl: '',
        },
        {
            productId: '7388078407872',
            variantId: '46728982724947',
            desc: '768Wh Capacity | 800W Output',
            productUrl: '',
        },
    ],
    de: [
        {
            productId: '14827510268239',
            variantId: '53660091449679',
            desc: '245 Wh Kapazität | 300 W Leistung',
            productUrl: '',
        },
        {
            productId: '14848608960847',
            variantId: '53707200004431',
            desc: '1-5 kWh Kapazität | 1 800 W Leistung',
            productUrl: '',
        },
        {
            productId: '9480253407567',
            variantId: '49424786358607',
            desc: '4 kWh Kapazität | 4 000 W Ausgang | LFP | 30 dB',
            productUrl: '',
        },
        {
            productId: '9535539315023',
            variantId: '49966509523279',
            desc: 'Qi2 15 W Drahtloses Laden | Bis zu 30 W Eingang/Ausgang',
            productUrl: '',
        },
        {
            productId: '8513034813775',
            variantId: '48399885533519',
            desc: '2-6 kWh erweiterbare Kapazität | Versorgt 99 % der Geräte mit X-Boost',
            productUrl: '',
        },
        {
            productId: '7898394657015',
            variantId: '48114985337167',
            desc: '23 % Umwandlungsrate | Bis zu 10 Jahre Garantie',
            productUrl: '',
        },
    ],
    fr: [
        {
            productId: '9594942095707',
            variantId: '49526901866843',
            desc: 'Capacité extensible de 1 à 5 kWh | 1 800 W de puissance de sortie',
            productUrl: '',
        },
        {
            productId: '8431233794395',
            variantId: '46793751789915',
            desc: 'Capacité extensible de 2 à 6 kWh',
            productUrl: '',
        },
        {
            productId: '9375271846235',
            variantId: '48799611879771',
            desc: 'Capacité 4 kWh | Puissance de sortie 4 000 W | LFP | 30 dB',
            productUrl: '',
        },
        {
            productId: '9432019370331',
            variantId: '48933508251995',
            desc: '15 W de puissanve sans fil | 30 W de puissance avec câble intégré',
            productUrl: '',
        },
        {
            productId: '9582183481691',
            variantId: '49471449530715',
            desc: '245 Wh de capacité | 300 W de puissance de sortie',
            productUrl: '',
        },
        {
            productId: '7929781977314',
            variantId: '46833280024923',
            desc: '768 Wh de capacité | 800 W de puissance de sortie',
            productUrl: '',
        },
    ],
    es: [
        {
            productId: '9432041029979',
            variantId: '49343927091547',
            desc: 'Carga inalámbrica Qi2 15 W | Entrada/salida de hasta 30 W',
            productUrl: '',
        },
        {
            productId: '9582187151707',
            variantId: '49471467520347',
            desc: ' Capacidad de 245 Wh | Salida de 300 W',
            productUrl: '',
        },
        {
            productId: '7850943152350',
            variantId: '46831957934427',
            desc: ' Capacidad de 768 Wh | Salida de 800 W',
            productUrl: '',
        },
        {
            productId: '9594953924955',
            variantId: '49526969139547',
            desc: ' Capacidad de 1-5 kWh | Salida de 1800 W',
            productUrl: '',
        },
        {
            productId: '8435033899355',
            variantId: '46787970269531',
            desc: 'Capacidad ampliable de 2 a 6 kWh',
            productUrl: '',
        },
        {
            productId: '7856793419998',
            variantId: '43593399828702',
            desc: 'Una tasa de conversión a luz solar del 23 %',
            productUrl: '',
        },
    ],
    it: [
        {
            productId: '9760871121245',
            variantId: '54413549240669',
            desc: 'Ricarica wireless Qi2 da 15 W | Ingresso/uscita fino a 30 W',
            productUrl: '',
        },
        {
            productId: '14734774665565',
            variantId: '54724579983709',
            desc: 'Capacità di 245 Wh | Uscita da 300 W',
            productUrl: '',
        },
        {
            productId: '7842358984945',
            variantId: '47043066823005',
            desc: 'Capacità di 768 Wh | Uscita da 800 W',
            productUrl: '',
        },
        {
            productId: '14845588341112',
            variantId: '54819109306744',
            desc: 'Capacità di 1-5 kWh | Uscita da 1.800 W',
            productUrl: '',
        },
        {
            productId: '8415773360477',
            variantId: '46891073274205',
            desc: ' Capacità espandibile di 2-6 kWh',
            productUrl: '',
        },
        {
            productId: '7843558523121',
            variantId: '43419242135793',
            desc: 'Un tasso di conversione del 23% dell’energia solare',
            productUrl: '',
        },
    ],
    za: [
        {
            productId: '7352407982289',
            variantId: '41935518335185',
            desc: 'Run 99% of appliances with X-Boost',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '7510978953425',
            variantId: '42363066450129',
            desc: '1800W AC output, powers 90% of home devices',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '7475747487953',
            variantId: '42253870366929',
            desc: '5100 BTU Fast Cooling, 6100 BTU Fast Heating',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '7027757449425',
            variantId: '41029915410641',
            desc: 'Run 80% of essential appliances. Charge phones, laptops or your drone',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '7504115826897',
            variantId: '42346262692049',
            desc: 'Run up to 99% of your consumer electronics',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '7027758137553',
            variantId: '41601871610065',
            desc: 'Power 99% of home appliances, including air conditioners and heaters',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
    ],
    au: [
        {
            productId: '7756517146822',
            variantId: '42768126181574',
            desc: '1024Wh Capacity (85Ah@12V) | 1800W Output| 2-year Warranty',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '8315583430854',
            variantId: '44211129614534',
            desc: '1536Wh Capacity (128Ah@12V) | 1800W Output | 5-year Warranty',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '8311879925958',
            variantId: '44062870503622',
            desc: '4000Wh Capacity (333Ah@12V) | 4000W Output | 5-year Warranty',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '7914502422726',
            variantId: '43045698371782',
            desc: '2048Wh Capacity (167Ah@12V) | 2400W Output| 2-year Warranty',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '7756526584006',
            variantId: '42673598824646',
            desc: '768Wh capacity (64Ah@12V) | 800W Output | 2-year Warranty',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '8398804713670',
            variantId: '44300891259078',
            desc: '3100W X-Boost AC output | Fast 2.3 hr full solar charge',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
    ],
    kr: [
        {
            productId: '7633244225705',
            variantId: '43452336144553',
            desc: '용량: 1,024Wh | 출력: 1800W',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        // {
        //     productId: '7680379224233',
        //     variantId: '43452252815529',
        //     desc: '용량: 1,024Wh | 출력: 1800W',
        //     productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        // },
        {
            productId: '8184730681513',
            variantId: '44393356165289',
            desc: '용량: 1,024Wh | 출력: 1800W',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '7924256276649',
            variantId: '44971095490729',
            desc: '용량: 2,048Wh | 출력: 2400W ',
            productUrl: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
        },
        {
            productId: '8336512975017',
            variantId: '44971094671529',
            desc: '용량: 256Wh | 출력: 300W',
            productUrl: '',
        },
    ],
};

export const pageId = 'FY2025_PRODUCT';
